import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
/**
 * Modal Component
 */
let VerifyAtmModalComponent = class VerifyAtmModalComponent {
    constructor(httpClient, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.successColor = '';
        this.backColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.showVerificationTypeButton = true;
        document.documentElement.style.overflowY = 'hidden';
        this.themeService.getTheme().subscribe((data) => {
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.backColor = this.themeService.getStyleAttribute('modal_back_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    ngOnInit() {
        this.showVerificationTypeButton = this.data.showVerificationTypeButton;
    }
    close() {
        this.modal.destroy();
    }
    submit() {
        this.httpClient.post('user/setpersonalverificationmethod', {
            verification_method_code: 'atm'
        }).subscribe((data) => {
            this.success();
            this.closeModal();
        });
    }
    closeModal() {
        document.documentElement.style.overflowY = '';
        this.modal.destroy();
    }
};
VerifyAtmModalComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
VerifyAtmModalComponent = __decorate([
    Component({
        selector: 'ecd-verify-atm-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./verify-atm-modal.component.html")).default
    })
], VerifyAtmModalComponent);
export { VerifyAtmModalComponent };
